import Dropdown from "@/lib/Dropdown";
import Menu from "@/lib/Menu";
import useOperationContext from "./useOperationContext";
import useGetCurrentQuoteRevision from "@/lib/SelectedQuoteRevisionIdContext/useGetCurrentQuoteRevision";
import CaretDownIcon from "@/lib/CaretDownIcon";
import { getIn, setIn } from "@/lib/utils";
import classnames from "classnames";

export default function Select({
  label,
  keyPath,
  suffix,
  width,
}: {
  label: string;
  keyPath: readonly PropertyKey[];
  suffix?: string;
  width?: number;
}) {
  const canEditQuoteRevision = useGetCurrentQuoteRevision()?.can_edit;
  const { operationData: data, updateOperation } = useOperationContext();
  const options = [
    { label: "Exact", value: "Exact" },
    { label: "1/8", value: "1/8" },
    { label: "1/4", value: "1/4" },
    { label: "1/2", value: "1/2" },
    { label: "Full", value: "Full" },
  ];
  const { id, draft, augmented } = data;
  const draftValue = getIn(draft, keyPath, null);
  const augmentedValue = getIn(augmented, keyPath, null);
  const value = draftValue ?? augmentedValue;

  function getSelectedLabel() {
    const optionLabel = options.find((o) => o.value === value)?.label;
    return optionLabel + (suffix && value !== "Exact" ? ` ${suffix}` : "");
  }

  return (
    <div
      className="h-7.5 px-1 pb-[4px] mt-1 flex flex-col justify-center items-start text-sm text-gray-800"
      style={{ width: width ?? 100 }}
    >
      <div className="px-1 text-xs text-gray-400 mt-[-8px] bg-white">
        {label}
      </div>
      <Dropdown
        disabled={!canEditQuoteRevision}
        trigger={({ expanded }: { expanded: boolean }) => (
          <div className={`px-1 flex gap-2 ${draftValue && "text-blue-600"}`}>
            <div>{getSelectedLabel()}</div>
            <CaretDownIcon expanded={expanded} />
          </div>
        )}
      >
        <Menu
          className="text-gray-800"
          itemGroups={[
            options.map(({ label, value: optionValue }) => ({
              label,
              click: () =>
                updateOperation(id, setIn(draft, keyPath, optionValue)),
              className: classnames({
                "bg-slate-100": optionValue === value,
              }),
            })),
          ]}
        />
      </Dropdown>
    </div>
  );
}
